import axios from 'axios';
import { Word } from '../models/Word';

interface WordResponse {
    code: number;
    message: string;
    data: Word[] | null;
}

interface UpdateStarResponse {
    code: number;
    message: string;
    data: {
        message: string;
    };
}

interface OrderBy {
    field: 'star' | 'update_time';  // Add other fields if needed
    desc: boolean;
}

const DEFAULT_ORDER_BY: OrderBy[] = [
    {
        field: 'star',
        desc: true
    },
    {
        field: 'update_time',
        desc: true
    }
];

export const WordService = {
    async fetchWords(
        userId: number, 
        page: number, 
        pageSize: number, 
        orderBy: OrderBy[] = DEFAULT_ORDER_BY
    ): Promise<Word[]> {
        try {
            const response = await axios.post<WordResponse>(
                'https://xianyou.uk/wordapi/api/v1/stars/query',
                {
                    user_id: userId,
                    page: page,
                    page_size: pageSize,
                    order_by: orderBy
                }
            );
            return response.data.data || [];
        } catch (error) {
            console.error('Error fetching words:', error);
            return [];
        }
    },

    async updateStar(
        userId: number, 
        word: string, 
        star: number, 
        delFlag: boolean = false
    ): Promise<boolean> {
        try {
            const response = await axios.put<UpdateStarResponse>(
                `https://xianyou.uk/wordapi/api/v1/stars/user/${userId}`,
                {
                    word: word,
                    star: star,
                    del_flag: delFlag
                }
            );
            return response.data.code === 200;
        } catch (error) {
            console.error('Error updating star:', error);
            return false;
        }
    }
}; 